import cn from 'classnames'
import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'
import Link from 'redux-first-router-link'
import PropTypes from 'prop-types'

import themeVars from 'ui_theme/site/globals/site.variables'
import SidebarLabel from 'components/App/DesktopView/Layout/Sidebar/SidebarLabel'
import customPropTypes from 'util/customPropTypes'

import styles from './styles.less'

function getPaddingValue(padded) {
  if (!padded) return ''

  const defaultPadding = Number(themeVars.bigSize)
  const depthPadding = Number(themeVars.largeSize)
  const paddingDepth = Number(padded)

  return `${paddingDepth * depthPadding + defaultPadding}rem !important`
}

SidebarItem.propTypes = {
  active: PropTypes.bool,
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  children: customPropTypes.children.isRequired,
  color: PropTypes.string,
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  size: PropTypes.oneOf(['large', 'small']),
  to: customPropTypes.to,
}

SidebarItem.defaultProps = {
  active: false,
  color: 'white',
  padded: false,
  size: 'small',
  to: null,
}

export default function SidebarItem({
  active,
  activeClassName,
  as: As = 'div',
  children,
  className,
  color,
  padded,
  size,
  to,
  ...rest
}) {
  const padding = css`
    padding-left: ${getPaddingValue(padded)};
  `

  const computedClassName = cn(styles.SidebarItem, padding, {
    [styles.SidebarItem_active]: active,
  })

  const content = (
    <SidebarLabel size={size} color={color}>
      {children}
    </SidebarLabel>
  )
  if (!to)
    return (
      <As className={computedClassName} {...rest}>
        {content}
      </As>
    )
  return (
    <Link to={to} className={computedClassName} {...rest}>
      {content}
    </Link>
  )
}
